<template>
  <b-container>
    <h4 class="text-center">Please log in to continue</h4>
    <b-form 
      v-if="show"
      v-on:reset.prevent="onReset" 
      v-on:submit.prevent="onSubmit">
      <!--username-->
      <b-form-group 
        id="usernameInputGroup" 
        label="Username" 
        label-for="usernameInput" 
        description="your username or interviewer ID">
        <b-form-input 
          required
          id="usernameInput" 
          type="text" 
          v-model="form.username" 
          placeholder="Enter username">
        </b-form-input>
      </b-form-group>
      <!--password-->
      <b-form-group 
        id="passwordInputGroup" 
        label="Password" 
        label-for="passwordInput" 
        description="(do not share this with anyone)">
        <b-form-input 
          required
          id="passwordInput" 
          type="password" 
          v-model="form.password" 
          placeholder="password"></b-form-input>
      </b-form-group>
      <!--reset and upload button-->
      <b-row>
        <b-col cols="12" md="10" class="pb-md-0 pb-2">
          <b-button 
            block
            type="submit" 
            :disabled="waiting"
            variant="outline-primary" 
            size="lg">
            Sign in <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
          </b-button>
        </b-col>
        <b-col cols="12" md="2">
          <b-button 
            block 
            type="reset" 
            variant="outline-danger" 
            size="lg">
            Clear
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <div class="text-center pt-4 mt-4">
      <a 
        href 
        @click.prevent="$router.push({path: '/passwordrecovery'})">
        forgot password?
      </a>
    </div>
    <!--alert with status update from server-->
    <template v-if="failureMessage !== null">
      <b-alert 
        show
        dismissible
        class="mt-4" 
        variant="danger">
        {{ failureMessage }}
      </b-alert>
    </template>
  </b-container>   
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      waiting: false,
      form: {
        username: '',
        password: ''
      },
      show: true,
      failureMessage: null
    }
  },
  methods: {
    ...mapActions('auth', {
      authenticate: 'authenticateUser'
    }),
    onSubmit() {
      // reset the alert message
      this.resetAlert()
      // compile the form data into data obj
      let formData = new FormData()
      formData.append('username', this.form.username)
      formData.append('password', this.form.password)
      
      // post the data to the backend
      let vm = this
      this.waiting = true
      axios.post('/login', formData)
      .then((response) => {
        console.log({response})
        vm.authenticate(response.data)
        vm.$router.push({path: '/loginotp'})
        this.waiting = false
      })
      .catch((err) => {
        console.log('login promise rejected, status code:' + 
          err.response.statusText)
        console.log(err)
        vm.setAlert(err.response.data)
        this.waiting = false
      })
    },
    onReset() {
      this.form.username = ''
      this.form.password = ''
      this.resetAlert()
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true })
    },
    resetAlert() {
      this.failureMessage = null
    },
    setAlert(message) {
      this.failureMessage = message
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue